/**
 * The brand's own name, domain and contact address - {@code SAAS.md §3.160}, FB-851.
 *
 * Ported from legacy's `marketing-site/src/brand.ts`, which had no AGOS counterpart: **four files in that tree and
 * this is the one nobody had read.** Its comment says what the three are for - *"SEO meta defaults, JSON-LD schema,
 * and any hardcoded UI strings that must follow rebrand"* - and `sections.tsx` imports `APP_CONTACT_EMAIL` for the
 * one thing this entry is about, the **Začať** button on every pricing tier.
 *
 * **Build-time overridable, with legacy's own defaults.** A second installation is a build variable rather than a
 * patch, which is what legacy intended and why the constants exist at all rather than being inlined. The manager's
 * login screen already reads `VITE_APP_NAME` with the identical `'PizzaMajstro'` default, so only the contact
 * address is new.
 *
 * <p><b>No type assertions, unlike legacy's.</b> Its `as string | undefined` exists because it has no
 * `ImportMetaEnv` declaration; `vite-env.d.ts` beside this file names all three, so lint refuses the assertion as
 * unnecessary - which is the declaration doing its job.
 *
 * **The default matters more than the override**, which is the §3.132 lesson: the owner's stored pricing section
 * carries no `ctaHref`, so a field the Tower can set and nothing defaults would have shipped and changed nothing on
 * their live site.
 */
export const APP_NAME = import.meta.env.VITE_APP_NAME ?? 'PizzaMajstro'

export const APP_DOMAIN = import.meta.env.VITE_APP_DOMAIN ?? 'pizzamajstro.sk'

export const APP_CONTACT_EMAIL =
  import.meta.env.VITE_APP_CONTACT_EMAIL ?? 'pizzamajstro@gmail.com'
